export default "/images/9fde45112c20c740431de33f4efb6c40.avif";